export const verifyPhone = (str) => {
  return /^[0-9]{11}$/.test(str);
};

export const verifyEmail = (str) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    str
  );
};

export const exhibitionService = [
  {
    title: '2026年"节水中国行·安徽合肥"主题宣传活动',
    content: '',
  },
  {
    title: '2026上海"五五购物节·皋品入沪六安周"活动',
    content: '',
  },
  {
    title: '第四届科交会专项活动——全国知名高校项目路演暨清华大学科技成果对接会活动',
    content: '',
  },
  {
    title: '第四届科交会专项活动——2026年蒙皖科技成果直通车暨第十六期"蒙皖聚"专题发布会',
    content: '',
  },
  {
    title: '第四届科交会专项活动——AI汽车科技与产业创新对接活动',
    content: '',
  },
  {
    title: '第四届科交会专项活动——中国科学院科技成果转化"融合点"行动安徽专场对接会',
    content: '',
  },
  {
    title: '第二届安徽省高校"百场千项"科技成果路演活动',
    content: '',
  },
  {
    title: '中国科学技术大学第十届墨子论坛',
    content: '',
  },
  {
    title: '第三届深空探测（天都）国际会议',
    content: '',
  },
  {
    title: '2025国家网络安全宣传周',
    content: '',
  },
  {
    title: '第八届中国医院后勤大会、第五届中国健康产业大会暨展览会',
    content: '',
  },
  {
    title: '第三届科交会专项活动——知名高校高谁品成果路演活动',
    content: '',
  },
  {
    title: '第二届长三角康养产业对接会',
    content: '',
  },
  {
    title: '2025年度皖美消费新场景遴选推广活动',
    content: '',
  },
  {
    title: '第一届（2024）安徽省高校"百场千项"科技成果路演活动启动暨企业应用场景和技术需求发布会',
    content: '',
  },
  {
    title: '安徽省国际商会第四届理事会第三次会议',
    content: '',
  },
  {
    title: '2024绿色物流发展大会',
    content: '',
  },
  {
    title: '全省重大基础设施政府和社会资本合作项目专题推介会',
    content: '',
  },
  {
    title: '2024年度皖美消费新场景评选活动',
    content: '',
  },
  {
    title: '首届长三角康养对接会',
    content: '',
  },
  {
    title: '第四届产业链创新链协同发展论坛暨合肥创新院成立十周年主题活动',
    content: '',
  },
  {
    title: '2024安徽省全民数字素养与技能提升月',
    content: '',
  },
  {
    title: '安徽省新能源和节能环保产业珠三角"双招双引"推介会',
    content: '',
  },
  {
    title: '高校在皖校友会青龙甸论坛',
    content: '',
  },
  {
    title: '2024新能源和节能环保产业科技成果对接会和应用场景对接会',
    content: '',
  },
  {
    title: '5.22国际生物多样性日',
    content: '',
  },
  {
    title: '2024全国汽车租赁行业高质量发展（合肥）会议',
    content: '',
  },
  {
    title: '淮南特产进合肥市场展示会',
    content: '',
  },
  {
    title: '第三届（2023）中国高校科技成果交易会',
    content: '',
  },
  {
    title: '安徽省新能源和节能环保产业长三角"双招双引"推介会',
    content: '',
  },
  {
    title: '安徽省现代服务业联合会成立大会暨第一届会员大会',
    content: '',
  },
  {
    title: '外资企业地方行安徽专场',
    content: '',
  },
  {
    title: '中国芜湖直播电商峰会',
    content: '',
  },
  {
    title: '世界制造业大会新能源和节能环保产业论坛',
    content: '',
  },
  {
    title: '第一届安徽省挥发性有机 污染物（VOCs治理论坛）',
    content: '',
  },
  {
    title: '全国体育大会',
    content:
      '第四届全国体育大会是合肥市乃至安徽省承办的规模最大、规格最高、影响最广的全国性体育赛会。中设国际会展集团在此次盛会中作为承办单位及主场服务商，为大会设计并制作了"四体会"系列纪念礼品，获得了第四届全国体育大会组委会颁发的"优秀组织奖"及"创意设计金奖"。',
  },
  {
    title: '中国金鸡百花电影节',
    content:
      '中国金鸡百花电影节是由中国文学艺术界联合会和中国电影家协会联合主办。第20届中国金鸡百花电影节暨第28届中国电影金鸡颁奖典礼在安徽省合肥市隆重举行。中设国际会展集团在此影视盛会中承担了整个活动的主场服务工作，并成功组织举办了"影视设备器材展"。',
  },
  {
    title: '国家网络安全宣传周',
    content:
      '国家网络安全宣传周由中央宣传部、中央网信办、教育部、工业和信息化部、公安部、中国人民银行、国家广播电视总局、全国总工会、共青团中央、全国妇联等十部门联合主办，是全国网络安全领域规格最高、规模最大的活动。',
  },
  {
    title: '全国大众创业万众创新活动周',
    content:
      '全国大众创业万众创新活动周，2022年主会场设在安徽省合肥市，第十九届中央政治局常委，国务院原总理李克强在北京人民大会堂出席2022年全国大众创业万众创新活动周，发表重要讲话，宣布活动周启动。',
  },
  {
    title: '中国高校科技成果交易会',
    content:
      '由教育部高等学校科学研究发展中心牵头，安徽省教育厅、上海市教育委员会、江苏省教育厅、浙江省教育厅、安徽省经济和信息化厅、合肥市人民政府联合主办，中设国际会展集团承办。教育部领导、省委省政府领导出席会议。',
  },
  {
    title: '国际商协会大会',
    content:
      '国际商协会大会由安徽省人民政府主办、中国国际商会支持，安徽省贸促会、国际商会承办。安徽省委省政府主要领导、中国贸促会有关领导出席会议。长三角和中部地区各省贸促会、国际商会机构负责人、四百余名外商及企业家出席会议。',
  },
  {
    title: '迪拜世博会安徽日',
    content:
      '迪拜世博会中国馆安徽活动日以"皖美科创 走向世界"为主题，采取线上线下融合方式举办。丰富多元的展览展示、虚实融合的互动体验、绚丽多彩的灯光展演、精彩纷呈的文化活动，将向世界全方位展示安徽各领域发展成就和高质量参与"一带一路"建设成果。迪拜世博会中国馆安徽活动日启动，副省长周喜安出席开幕式并致辞。',
  },
  {
    title: '中国航天日',
    content:
      '本届"中国航天日"以"格物致知 叩问苍穹"为主题，活动启动仪式现场公布了2023年"中国航天公益形象大使"，颁发2022年度中国航天基金会"钱学森最高成就奖""钱学森杰出贡献奖""航天创新团队奖"以及"航天国际合作奖"，并发布我国首次火星探测火星全球彩色影像图和嫦娥五号任务月球样本联合研究科学成果。',
  },
];
